export default "__VITE_PUBLIC_ASSET__b712a461__"